import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ExquisiteSurfaceArtistry from "./sections/ExquisiteSurfaceArtistry";
import AlliloopBuildsBridgesAcrossTheCareEconomy from "./sections/AlliloopBuildsBridgesAcrossTheCareEconomy";
import WorkforceSolutions from "./sections/WorkforceSolutions";
import FifteenThousandJobsFilled from "./sections/FifteenThousandJobsFilled";
import Employers from "./sections/Employers";
import JobSeekers from "./sections/JobSeekers";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ExquisiteSurfaceArtistry />
      <AlliloopBuildsBridgesAcrossTheCareEconomy />
      <WorkforceSolutions />
      <FifteenThousandJobsFilled />
      <Employers />
      <JobSeekers />
      <Footer />
    </div>;
}